import React from "react";
import { Helmet } from "react-helmet";
import { SeoHeaderProps } from ".";

export const SeoHeader: React.FC<SeoHeaderProps> = ({ documentTitle, metaDescription, canonicalLink }) => {
  return (
    <Helmet>
      <title>{documentTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={window.location.host + canonicalLink} />
    </Helmet>
  );
};

SeoHeader.defaultProps = {
  canonicalLink: window.location.pathname,
};
